import { PayloadAction } from '@reduxjs/toolkit';

import { ConditionAddress, DesignState } from 'editor/src/store/design/types';

const updateConditionDescriptionReducer = (
  state: DesignState,
  action: PayloadAction<{ address: ConditionAddress; description: string }>,
) => {
  const { address, description } = action.payload;
  const { spreadIndex, conditionId } = address;
  const condition = state.designData?.spreads[spreadIndex]?.conditionGroup?.conditions[conditionId];
  if (!condition) {
    return;
  }

  // Empty means "no notice" rather than an empty paragraph the buyer scrolls past.
  condition.description = description.trim() ? description : undefined;
};

export default updateConditionDescriptionReducer;
